define("shared/services/shared/popup-manager", ["exports", "@ember/service", "later/services/errors", "shared/lib/popup-instance"], function (_exports, _service, _errors, _popupInstance) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.defineProperty(_exports, "PopupInstance", {
    enumerable: true,
    get: function () {
      return _popupInstance.PopupInstance;
    }
  });
  _exports.default = _exports.PopupManagerService = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"@ember/service",0,"later/services/errors",0,"shared/lib/popup-instance"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let PopupManagerService = _exports.PopupManagerService = (_class = class PopupManagerService extends _service.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "errors", _descriptor, this);
      _defineProperty(this, "popups", {});
    }
    createPopup(name, config) {
      this.closeAllPopups();
      const createdPopup = new _popupInstance.PopupInstance({
        name,
        config: {
          ...config,
          _manager: {
            onError: (error, severity) => this.onError(error, severity),
            onOpened: () => this.onOpenedPopup(name),
            onClosed: error => this.onClosedPopup(name, error),
            onMessageReceived: message => this.onMessageReceivedPopup(name, message),
            onMessageSent: message => this.onMessageSentPopup(name, message)
          }
        }
      });
      this.popups[name] = createdPopup;
      return createdPopup;
    }
    findPopup(name) {
      const found = this.popups[name];
      if (!found) {
        return undefined;
      }
      return found;
    }
    listPopups() {
      return Object.values(this.popups).filter(Boolean);
    }
    closePopup(name) {
      const popup = this.findPopup(name);
      if (!popup) {
        console.warn(`Popup window "${name}" doesn't exist or has already been closed.`);
        return;
      }
      popup.close();
    }
    closeAllPopups() {
      this.listPopups().forEach(popupInstance => this.closePopup(popupInstance.name));
    }
    onClosedPopup(name, error) {
      const popup = this.findPopup(name);
      if (!popup) {
        return;
      }
      this.errors.log(error ? `Popup closed with name "${name}" and encountered an error: ${error}` : `Popup closed with name "${name}"`, undefined, _errors.ErrorSeverity.Debug);
      delete this.popups[name];
    }
    onOpenedPopup(name) {
      this.errors.log(`Popup opened with name "${name}"`, undefined, _errors.ErrorSeverity.Debug);
    }
    onMessageReceivedPopup(name, message) {
      this.errors.log(`Popup with name "${name}" received a message: ${JSON.stringify(message.data)}`, undefined, _errors.ErrorSeverity.Debug);
    }
    onMessageSentPopup(name, message) {
      this.errors.log(`Popup with name "${name}" sent a message: ${JSON.stringify(message.data)}`, undefined, _errors.ErrorSeverity.Debug);
    }
    onError(error, severity) {
      this.errors.log(error, undefined, severity);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  var _default = _exports.default = PopupManagerService;
});